export const ALLOWED_CHAR_CODES = [
	"ç",
	"Ç",

	"ñ",
	"Ñ",

	"á",
	"Á",
	"â",
	"Â",
	"à",
	"À",
	"ã",
	"Ã",
	"ä",
	"Ä",

	"é",
	"É",
	"ê",
	"Ê",
	"è",
	"È",
	"ë",
	"Ë",

	"í",
	"Í",
	"ì",
	"Ì",
	"ï",
	"Ï",
	"î",
	"Î",

	"ó",
	"Ó",
	"ô",
	"Ô",
	"õ",
	"Õ",
	"ò",
	"Ò",
	"ö",
	"Ö",

	"ú",
	"Ú",
	"ù",
	"Ù",
	"ü",
	"Ü",
	"û",
	"Û",
];

export enum KeyTypeValue {
	EMAIL = "EMAIL",
	PHONE = "PHONE",
	EVP = "EVP",
	CPF = "CPF",
	CNPJ = "CNPJ",
}

export enum KeyCreationOptionValues {
	EMAIL = "EMAIL",
	PHONE = "PHONE",
	EVP = "EVP",
	CPF_CNPJ = "CPF_CNPJ",
}

export const KeyTypeText: {
	[value in KeyTypeValue]: string;
} = {
	[KeyTypeValue.PHONE]: "Telefone",
	[KeyTypeValue.CNPJ]: "CNPJ",
	[KeyTypeValue.CPF]: "CPF",
	[KeyTypeValue.EMAIL]: "E-mail",
	[KeyTypeValue.EVP]: "Chave Pessoal",
};

export const INSTITUTIONS_PAGE_SIZE = 30;
// export const getKeyType = (
// 	keyCreationOptionValue: KeyCreationOptionValues,
// 	keyName: string
// ) => {
// 	const { CPF, CNPJ } = KeyTypeValue;

// 	switch (keyCreationOptionValue) {
// 		case KeyCreationOptionValues.CPF_CNPJ:
// 			return isCpf(keyName) ? CPF : CNPJ;
// 		default:
// 			return KeyTypeValue[keyCreationOptionValue];
// 	}
// };

export enum OnboardingScreen {
	WELCOME = "WELCOME",
	MY_KEYS = "MY_KEYS",
}

export enum PaymentNotificationStatus {
	PENDING = "pending",
	APPROVED = "approved",
	REJECTED = "rejected",
}

export enum QR_STATUS {
	DISABLED = 0,
	ENABLED = 1,
}

export const QR_CODE_CATCH_VIBRATION_TIME = 100;

export const LOGGED_USER_KEY = "tvm.current.user";

export const SIGNED_IN = "user.signed.in";
export const CODE_REQUESTED = "user.code.requested";
export const LICENSE_EXPIRATION_DATE = "user.code.expiration.date";
export const LICENSE = "user.code.data";

export enum DbInstance {
	JSON_DB = "json-db",
}

export const SYS_PARTITION_KEY = "sys.partition.key";
export const PARTITION_KEY = "partition.key";

export const HTML_INTERPOLATION_DELIMITER = "{{}}";
